import List from './list';
import SinglePostgresql from './single/postgresql';
import SingleMongo from './single/mongodb';
import Monitoring from './monitoring';

export default {
  List,
  postgresql: {
    Single: SinglePostgresql,
  },
  mongodb: {
    Single: SingleMongo,
  },
  Monitoring,
};
